export const meilisearchTools = [
    {
        type: 'function' as const,
        function: {
            name: '_meiliSearchProgress',
            description: 'Display the progress of a search operation',
            parameters: {
                type: 'object',
                properties: {
                    call_id: {
                        type: 'string',
                        description: 'The ID of the search call',
                    },
                    function_name: {
                        type: 'string',
                        description: 'The name of the function being executed',
                    },
                    function_arguments: {
                        type: 'string',
                        description: 'The arguments passed to the function',
                    },
                },
                required: ['call_id', 'function_name', 'function_arguments'],
            },
        },
    },
    {
        type: 'function' as const,
        function: {
            name: '_meiliSearchSources',
            description: 'Return the sources found by a search operation',
            parameters: {
                type: 'object',
                properties: {
                    call_id: {
                        type: 'string',
                        description: 'The ID of the search call',
                    },
                    sources: {
                        type: 'array',
                        description: 'Array of search result sources',
                        items: {
                            type: 'object',
                        },
                    },
                },
                required: ['call_id', 'sources'],
            },
        },
    },
    {
        type: 'function' as const,
        function: {
            name: '_meiliAppendConversationMessage',
            description: 'Append a new message to the conversation based on internal operations',
            parameters: {
                type: 'object',
                properties: {
                    role: {
                        type: 'string',
                        description: 'The role of the message author (user or assistant)',
                    },
                    content: {
                        type: 'string',
                        description: 'The message content (optional if tool_calls is specified)',
                    },
                    tool_calls: {
                        type: 'array',
                        description: 'Tool calls generated by the model (optional)',
                        items: {
                            type: 'object',
                        },
                    },
                    tool_call_id: {
                        type: 'string',
                        description: 'Tool call that this message is responding to (optional)',
                    },
                },
                required: ['role'],
            },
        },
    },
];
